const useAuth = () => {
  const token = localStorage.getItem('token');
  return {
    isLogin: Boolean(token)
  };
};

export default useAuth;